const ResultsSearchBar = ({
  query,
  handleTextAreaInput,
  handleTextAreaKeyPress,
  handleSearch,
  handleClear,
  sessionDropdownDisabled
}) => {
  return (
    <div className="search-bar-container">
      <div className="search-bar-textarea-container">
        <one-ux-textarea
          style={{
            pointerEvents: !sessionDropdownDisabled ? 'auto' : 'none',
            opacity: sessionDropdownDisabled ? 0.2 : 1
          }}
          class="search-bar-textarea"
          label="Textarea"
          line-count="6"
          placeholder="Chat with Stratsys AI! 
Use Shift + Enter for new line."
          value={query}
          onInput={!sessionDropdownDisabled && handleTextAreaInput}
          onKeyDown={!sessionDropdownDisabled && handleTextAreaKeyPress}></one-ux-textarea>
      </div>

      <div className="search-button-container">
        <one-ux-button
          class="ai-search-button"
          onClick={handleSearch}
          style={{
            pointerEvents: !sessionDropdownDisabled ? 'auto' : 'none',
            opacity: sessionDropdownDisabled ? 0.2 : 1
          }}
          label="Search"
          purpose="main"
          weight="normal"
          state="default">
          {' '}
        </one-ux-button>
        <one-ux-button
          class="new-session-button"
          onClick={handleClear}
          label="New Session"
          purpose="default"
          weight="normal"
          state="default"
          implicit>
          {' '}
        </one-ux-button>
      </div>
    </div>
  )
}
export default ResultsSearchBar
